import { PropsWithChildren } from 'react';

export type TabPanelProps = PropsWithChildren<{
  selectedTab: number;
  tabId: number;
}>

export const TabPanel = ({ selectedTab, tabId, children }: TabPanelProps) => {
  return (
    <div role='tabpanel' hidden={selectedTab !== tabId}>
      {children}
    </div>
  );
};
